import { Button, Checkbox, Form, Input, Modal, Select, Space, Typography } from "antd";
import { useState } from "react";

import { showNotification } from "../../../../utils/notification";
import MultipleTagInput from "../../../common-utils/MultipleTagInput";
import TextEditor from "../../../common-utils/TextEditor";

const { Option } = Select;
const { Text } = Typography;

const TEST_EMAILS = [
  "priyansh@tle-eliminators.com",
  "viraj@tle-eliminators.com",
  "priyam@tle-eliminators.com",
  "pavitra@tle-eliminators.com",
  "priyansh31dec@gmail.com",
  "priyansh19077@iiitd.ac.in",
  "mridul22303@iiitd.ac.in",
  "abhay@tle-eliminators.com"
];

const CreateCampaignModal = ({
  senderEmailOptions = [],
  personalizationVariables = [],
  isModalOpen = false,
  setIsModalOpen = () => {},
  handleSendTestEmails = () => {},
  handleCampaignCreation = () => {}
}) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isTestRunCompleted, setIsTestRunCompleted] = useState(false);
  const [isRichTextEditorRequested, setIsRichTextEditorRequested] = useState(false);

  const [form] = Form.useForm();

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleFormSubmit = (values) => {
    handleCampaignCreation(values);
  };

  const handleInsertPersonalizationVariable = (token) => {
    const currentBody = form.getFieldValue("emailHtmlBody") || "";
    form.setFieldValue("emailHtmlBody", `${currentBody} {{${token}}} `);
  };

  const handleSendTestEmailsWrapper = () => {
    setIsButtonDisabled(true);

    // Re-enable the button after 5 seconds
    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 5000);

    const testEmailsList = form.getFieldValue("testEmailsList");
    const emailSubject = form.getFieldValue("emailSubject");
    const emailHtmlBody = form.getFieldValue("emailHtmlBody");
    const senderId = form.getFieldValue("senderId");

    if (!emailHtmlBody || !emailSubject || !testEmailsList?.length || !senderId) {
      showNotification(
        "Missing Param",
        "Please enter body, subject, senderId and test emails.",
        "error"
      );

      return;
    }
    handleSendTestEmails({
      testEmailsList,
      emailSubject,
      emailHtmlBody,
      senderId
    });
    setIsTestRunCompleted(true);
  };

  return (
    <Modal
      title="Create Campaign"
      open={isModalOpen}
      footer={[]}
      onOk={handleOk}
      onCancel={handleCancel}
      width="1200px"
    >
      <Form form={form} name="create_mailing_list_modal_form" onFinish={handleFormSubmit}>
        <Form.Item
          name="name"
          label="Name"
          rules={[
            {
              required: true,
              message: "Please enter the name!"
            }
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="description"
          label="Description"
          rules={[
            {
              required: true,
              message: "Please enter the description!"
            }
          ]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item
          name="emailSubject"
          label="Email Subject"
          rules={[
            {
              required: true,
              message: "Please select a subject!"
            }
          ]}
        >
          <Input />
        </Form.Item>

        <Checkbox
          onChange={(e) => {
            setIsRichTextEditorRequested(e.target.checked);
          }}
        >
          {" "}
          Open Rich Editor{" "}
        </Checkbox>

        <br />
        <br />

        {personalizationVariables.length > 0 && (
          <Space direction="vertical" size={4} style={{ marginBottom: "8px" }}>
            <Text strong>Insert Personalization Variable</Text>
            <Space>
              {personalizationVariables.map(({ token, label }) => (
                <Button
                  key={token}
                  size="small"
                  onClick={() => handleInsertPersonalizationVariable(token)}
                >
                  {label}
                </Button>
              ))}
            </Space>
            {personalizationVariables
              .filter(({ fallbackExample }) => fallbackExample)
              .map(({ token, fallbackExample }) => (
                <Text key={token} type="secondary">
                  {fallbackExample}
                </Text>
              ))}
          </Space>
        )}

        {isRichTextEditorRequested ? (
          <Form.Item
            name="emailHtmlBody"
            label="Email Body"
            rules={[
              {
                required: true,
                message: "Please enter the body of the email"
              }
            ]}
          >
            <TextEditor />
          </Form.Item>
        ) : (
          <Form.Item
            name="emailHtmlBody"
            label="Enter Raw HTML"
            rules={[
              {
                required: true,
                message: "Please enter the body of the email"
              }
            ]}
          >
            <Input.TextArea rows={4} />
          </Form.Item>
        )}

        <br />
        <br />

        <Form.Item
          label="Sender Email"
          name="senderId"
          rules={[{ required: true, message: "Please select a sender email!" }]}
        >
          <Select>
            {Object.values(senderEmailOptions || []).map((emailOption) => (
              <Option key={emailOption.value} value={emailOption.value}>
                {emailOption.label}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="testEmailsList" label="Test Receiver Emails">
          <MultipleTagInput suggestions={TEST_EMAILS} />
        </Form.Item>

        <div
          style={{
            display: "flex",
            gap: "10px",
            flexWrap: "wrap"
          }}
        >
          <Button
            type="primary"
            onClick={() => {
              handleSendTestEmailsWrapper();
            }}
            disabled={isButtonDisabled}
          >
            Send Test Emails
          </Button>

          <Form.Item className="submit-btn">
            <Button type="primary" htmlType="submit" disabled={!isTestRunCompleted}>
              Create
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};
export default CreateCampaignModal;
